export const CT_PARAMS = {
  BANNER_NAME: 'bannerName',
  BANNER_LOCATION: 'bannerLocation',
  BANNER_POSITION: 'bannerPosition',
  DASHBOARD_BANNER_CAROUSEL: 'Dashboard Carousel Banners',
  TYPE: 'type',
  GAME_NAME: 'gameName',
  VIDEO_FILE_NAME: 'videoFileName',

  REFERRAL_STEP_TITLE: 'referralStepTitle',
  REFERRAL_STEP_DESCRIPTION: 'referralStepDescription',
  FILLED_REFERRAL_CODE: 'filledReferralCode',

  VERTICAL_POSITION: 'vertical_position',
  HORIZONTAL_POSITION: 'horizontal_position',
  WIDGET_TYPE: 'widget_type',
  COUNT_OF_GAMES: 'countOfGames',
  GAME_POSITION: 'gamePosition',

  SCREEN_NAME: 'ScreenName',
  SCREEN_PAYMENT: 'payment',
  SCREEN_SIGNUP: 'sign_up',
  SCREEN_SIGN_IN: 'sign_in',
  SCREEN_PHONE_OTP: 'phone_otp',
  SCREEN_GAME_RULE: 'game_rules',
  SCREEN_LANGUAGE_SELECTION: 'language_selection',
  LANGUAGE: 'Language',
  ERROR_MESSAGE: 'msg',

  SCREEN_ADD_MONEY: 'add_money',
  SCREEN_WITHDRAW_SUCCESS: 'withdraw_success',
  SCREEN_WINNING_GAME: 'winning_screen',

  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',

  LIKED: 'liked',
  MODE: 'mode',
  INITIATED_FROM: 'initiated_from',
  LB_TITLE: 'lb_title',
  GAME_FILTER: 'game_filter',
  PROFILE_TYPE: 'type',
  SOURCE_WIDGET: 'sourceWidget',

  METHOD: 'method',
  AMOUNT: 'amount',
  STATUS: 'status',
  REASON: 'reason',
  MODE_VISIBLE: 'modeVisible',
  NEW_VALUE: 'newValue',

  LEADERBOARD_ID: 'leaderBoardId',
  EF_RANGE: 'ef_range',
  START_TIME: 'start_time',
  END_TIME: 'end_time',
  REWARD_POOL: 'reward_pool',

  SERIAL_NUMBER: 'SerialNumber',
  USERNAME: 'un',
  AMOUNT_WON: 'AMOUNT_WON',

  QUESTION_NO: 'questionNo',
  OPTION_NO: 'optionNo',
  REWARD_MISSED: 'rewardMissed',
  DATE: 'date',

  // VIP
  SOURCE: 'source',
  REWARD_TYPE: 'rewardType',
  DICE_NAME: 'diceName',

  // DGP
  ENTRY_FEE: 'entryFee',
  GAME_FORMAT: 'gameFormat'
}
